import React, { FunctionComponent } from 'react';
import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Typography from '../typography';

interface ComingSoonPillProps {
  className?: string;
}

const ComingSoonPill: FunctionComponent<ComingSoonPillProps> = ({
  className,
  children,
}) => {
  return (
    <ComingSoonType className={className || ''} weight="700" type="small">
      {children ? children : <Translate id="COMMON.COMING_SOON" />}
    </ComingSoonType>
  );
};

export default ComingSoonPill;

const ComingSoonType = styled(Typography)`
  padding: 6px 8px;
  color: ${({ theme }) => theme.colors.hintText};
  background: ${({ theme }) => theme.colors.hint};
  border-radius: 12px;
  user-select: none;
  @media ${({ theme }) => theme.device.tablet} {
    padding: 4px 6px;
  }
`;
